// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"592":"ed7a82e1","875":"06482700","985":"90b4d30a"}[chunkId] + ".chunk.css";
};